import React from 'react';
import { ACTION_LABELS, labelFor } from './labels';
import './ProfileBuildPathReport.css';

export const POSITION_HEADINGS = ['1st', '2nd', '3rd', '4th', '5th or later'];

/**
 * Which action athletes do at which point in their journey.
 *
 * Rows are actions, columns are "this was the athlete's Nth first-time
 * action". Each cell is the share of athletes who did that action at that
 * point, out of everyone with at least one tracked action. Replaces the old
 * Sankey, which drew no labels and hid cyclic paths to avoid crashing recharts.
 */
export default function BuildOrderHeatmap({ positions = {}, athletes = 0 }) {
  // Earliest-happening actions first: lowest average position, ties by volume.
  const rows = Object.entries(positions)
    .map(([screen, counts]) => {
      const total = counts.reduce((a, b) => a + b, 0);
      const avg = total ? counts.reduce((sum, c, i) => sum + c * i, 0) / total : 0;
      return { screen, counts, total, avg };
    })
    .sort((a, b) => a.avg - b.avg || b.total - a.total);

  if (!rows.length || athletes <= 0) {
    return <p className="report-note">Not enough ordered actions yet to show a build order.</p>;
  }

  return (
    <div className="heat-wrap">
      <table className="heat" aria-label="Build order heatmap">
        <thead>
          <tr>
            <th scope="col">Action</th>
            {POSITION_HEADINGS.map((h) => <th key={h} scope="col">{h}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.screen}>
              <td>{labelFor(ACTION_LABELS, r.screen)}</td>
              {r.counts.map((count, i) => {
                const share = count / athletes;
                const alpha = count === 0 ? 0 : Math.min(1, 0.1 + share * 2.2);
                return (
                  <td
                    key={i}
                    className="heat__cell"
                    data-testid={`heat-${r.screen}-${i}`}
                    title={`${count} athletes`}
                    style={{
                      background: count === 0 ? '#F5F8F6' : `rgba(0, 102, 204, ${alpha.toFixed(2)})`,
                      color: alpha > 0.5 ? '#fff' : '#07131F',
                    }}
                  >
                    {count === 0 ? '' : `${Math.round(share * 100)}%`}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
